// @flow

import { AuthLocalStorage as SpeedAuthLocalStorage } from 'speed-js-core';

export const LANDING_TAB_UNREGISTERED_LC_KEY = 'auth-token-invalid';


export default class AuthLocalStorage extends SpeedAuthLocalStorage {
    getToken = () => {
        const unregisteredLandingTab = localStorage.getItem(LANDING_TAB_UNREGISTERED_LC_KEY);
        const wsConnectionId = sessionStorage.getItem('wsConnectionId');

        if (unregisteredLandingTab && unregisteredLandingTab !== wsConnectionId) {
            return Promise.resolve(null);
        }
        return Promise.resolve(localStorage.getItem('authToken') || null);
    };
}
